import React, { useEffect, useState } from 'react'
import { Box, Grid, TextField } from '@mui/material'
import { useFormik } from "formik"
import * as yup from "yup"
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { createOrder } from '../../store/features/order/orderSlice'
import { API_BASE_URL, config } from '../../config/apiConfig'

const Checkout = () => {
  document.title = 'MACRUM | Checkout'
  document.querySelector('meta[rel="canonical"]').setAttribute('href', 'https://macrum.in/checkout')
  const [cartProduct, setCartProduct] = useState([])
  const [billingInfo, setBillingInfo] = useState(null)
  const [totalAmount, setTotalAmount] = useState(null)
  const [paymentInfo, setPaymentInfo] = useState({orderId: "", paymentId: ""})
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {cartItem} = useSelector((store) => store.cart)
  console.log("Cart Item", cartItem)

  let billingDetailsSchema = yup.object({
    name: yup.string().required("Your Name / Company Name is Required"),
    email: yup.string().email("Email Should be valid").required("Email is Required"),
    phone: yup.number().required("Phone Number is Required"),
    pinCode: yup.number().required("Pin Code is Required"),
    address: yup.string().required("Address is Required"),
  })
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      GSTIN: "",
      pinCode: "",
      address: "",
    },
    validationSchema: billingDetailsSchema,
    onSubmit: (values) => {
      setBillingInfo(values)
      setTimeout(() => {
        checkoutHandler()
      }, 300);
    }
  })

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement('script')
      script.src = src
      script.onload = () => {
        resolve(true)
      }
      script.onerror = () => {
        resolve(false)
      }
      document.body.appendChild(script)
    })
  }

  useEffect(() => {
    let item = {product: cartItem._id}
    // let item = []
    for (let i = 0; i < cartItem.length; i++) {
      item.push({product: cartItem[i]._id})
    }
    setCartProduct(item)
  }, [cartItem])

  useEffect(() => {
    let total = cartItem.sellingPrice
    // let total = 0
    for (let i = 0; i < cartItem.length; i++) {
      total += cartItem[i].sellingPrice
    }
    setTotalAmount(total)
  }, [cartItem])

  const checkoutHandler = async () => {
    const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js')
    if (!res) {
      alert('Razorpay SDK failed to load.')
      return
    }
    const result = await axios.post(`${API_BASE_URL}/payment/order/checkout`, {amount: totalAmount}, config)
    if (!result) {
      alert('Something went wrong')
      return
    }

    const { amount, id: order_id, currency } = result.data.data
    const options = {
      key: 'rzp_test_dXAtjzfNCGJDUY',
      amount: amount,
      currency: currency,
      name: 'MACRUM',
      description: 'Transaction',
      image: '',
      order_id: order_id,
      handler: async function (response) {
        const data = {
          orderCreationId: order_id,
          razorpayPaymentId: response.razorpay_payment_id,
          razorpayOrderId: response.razorpay_order_id,
        }

        const result = await axios.post(`${API_BASE_URL}/payment/order/paymentVerification`, data, config)
        
        // setPaymentInfo({
        //   orderId: response.razorpay_order_id,
        //   paymentId: response.razorpay_payment_id,
        // })
        const paymentInfo = {
          orderId: response.razorpay_order_id,
          paymentId: response.razorpay_payment_id,
        }
        dispatch(createOrder({
          items: cartProduct,
          totalPrice: totalAmount,
          billingInfo: formik.values,
          paymentInfo: paymentInfo,
        }))
        navigate('/payment-success')
      },
      prefill: {
        name: billingInfo?.name,
        email: billingInfo?.email,
        contact: billingInfo?.phone,
      },
      notes: {
        address: billingInfo?.address,
      },
      theme: {
        color: '#020617',
      },
    }

    const rzp = new window.Razorpay(options)
    rzp.open()
  }

  const handleBack = () => {
    navigate('/buy-macrum')
  }

  return (
    <div>
      <div className='flex flex-col-reverse md:grid grid-cols-3 p-4 pt-32 gap-2'>
        <div className='col-span-2'>
          <form onSubmit={formik.handleSubmit}>
            <div className='bg-blue-950 border-blue-800 border rounded-md shadow-md p-5'>
              <p className='text-xl font-semibold pb-5'>Billing Details</p>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    id='name'
                    name='name'
                    label='Your Name / Company Name'
                    fullWidth
                    onChange={formik.handleChange("name")}
                    value={formik.values.name}
                    onBlur={formik.handleBlur("name")}
                  />
                  <Box sx={{ color: '#ff0000', fontSize: 12 }}>
                    {formik.touched.name && formik.errors.name ? (
                      <div>{formik.errors.name}</div>
                    ) : null}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id='email'
                    name='email'
                    label='Email'
                    fullWidth
                    onChange={formik.handleChange("email")}
                    value={formik.values.email}
                    onBlur={formik.handleBlur("email")}
                  />
                  <Box sx={{ color: '#ff0000', fontSize: 12 }}>
                    {formik.touched.email && formik.errors.email ? (
                      <div>{formik.errors.email}</div>
                    ) : null}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id='phone'
                    name='phone'
                    label='Phone Number'
                    fullWidth
                    onChange={formik.handleChange("phone")}
                    value={formik.values.phone}
                    onBlur={formik.handleBlur("phone")}
                  />
                  <Box sx={{ color: '#ff0000', fontSize: 12 }}>
                    {formik.touched.phone && formik.errors.phone ? (
                      <div>{formik.errors.phone}</div>
                    ) : null}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id='GSTIN'
                    name='GSTIN'
                    label='GSTIN No.'
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id='pinCode'
                    name='pinCode'
                    label='Pin Code'
                    fullWidth
                    onChange={formik.handleChange("pinCode")}
                    value={formik.values.pinCode}
                    onBlur={formik.handleBlur("pinCode")}
                  />
                  <Box sx={{ color: '#ff0000', fontSize: 12 }}>
                    {formik.touched.pinCode && formik.errors.pinCode ? (
                      <div>{formik.errors.pinCode}</div>
                    ) : null}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id='address'
                    name='address'
                    label='Address'
                    fullWidth
                    multiline
                    rows={4}
                    onChange={formik.handleChange("address")}
                    value={formik.values.address}
                    onBlur={formik.handleBlur("address")}
                  />
                  <Box sx={{ color: '#ff0000', fontSize: 12 }}>
                    {formik.touched.address && formik.errors.address ? (
                      <div>{formik.errors.address}</div>
                    ) : null}
                  </Box>
                </Grid>
              </Grid>
            </div>
            <div className='py-10'>
              <div className='flex justify-end gap-4'>
                <button
                  onClick={handleBack}
                  className='bg-blue-950 border-blue-800 text-lg border rounded py-2 px-8 font-semibold'
                  type='button'
                >
                  Back
                </button>
                <button
                  className='bg-blue-950 border-blue-800 text-lg border rounded py-2 px-4 font-semibold'
                  type='submit'
                >
                  Proceed to payment
                </button>
              </div>
            </div>
          </form>
        </div>
        <div className='bg-blue-950 border-blue-800 h-64 mt-2 md:mt-0 border rounded-md shadow-md'>
          <div className='p-5'>
            <p className='text-xl font-semibold pb-4'>Order Summary</p>
            <p className='text-2xl font-semibold'>{cartItem.title}</p>
            <p className='font-semibold pt-4'>Valid : {cartItem.validation}</p>
            <div className='flex pt-4 gap-4'>
              <div className='text-3xl font-semibold'>
                <span className='text-xl pr-1'>INR</span>
                {cartItem.sellingPrice}
              </div>
              <div className='flex items-center'>
                <p>({cartItem.taxType})</p>
              </div>
            </div>
            <hr className='w-full my-4 border-slate-700' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Checkout
